import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import ModalEvent from "../../../../components/elements/ModalEvent";
import esLocale from "@fullcalendar/core/locales/es";
import { message } from "antd";


const Calendario = () => {
  const [isEventModal, setIsEventModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();

  

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Evento agregado correctamente!",
    });
  };

  const errorDate = () => {
    messageApi.open({
      type: "error",
      content: "La fecha y hora de finalización deben ser posteriores a la fecha y hora de inicio"
    })
  }

  const deleteEvent = () => {
    messageApi.open({
      type: "success",
      content: "Evento eliminado correctamente",
    });
  };

  const updatedEvent = () => {
    messageApi.open({
      type: "success",
      content: "Evento actualizado correctamente",
    });
  };

  const handleDateClick = (arg) => {
    setSelectedDate(arg.dateStr);
    setSelectedEvent(null);
    setIsEventModal(true);
  };

  const handleEventClick = (info) => {
    setSelectedEvent(info.event);
    setIsEventModal(true);
  };

  const handleEventSubmit = (eventData) => {
    if (selectedEvent) {
      const updatedEvents = events.map((event) =>
        event.id === selectedEvent.id ? { ...event, ...eventData } : event
      );
      setEvents(updatedEvents);
      updatedEvent();
    } else {
      const newEvent = {
        id: String(new Date().getTime()),
        ...eventData,
      };
      setEvents([...events, newEvent]);
      success();
    }
    setIsEventModal(false);
  };

  const handleDeleteEvent = () => {
    if (selectedEvent) {
      const updatedEvents = events.filter((event) => event.id !== selectedEvent.id);
      setEvents(updatedEvents);
      setIsEventModal(false);
      deleteEvent();
    }
  };

  return (
    <div className="w-full h-screen overflow-hidden text-text"> 
      {contextHolder}
      <ModalEvent
        isEventModal={isEventModal}
        setIsEventModal={setIsEventModal}
        onSubmit={handleEventSubmit}
        selectedDate={selectedDate}
        selectedEvent={selectedEvent}
        onDelete={handleDeleteEvent}
        errorDate={errorDate}
      />

      <div className="flex justify-end mr-28 my-3 ">
        <button onClick={() => setIsEventModal(true) } className="border border-border p-2 rounded bg-background font-poppina ">Crear Evento</button>
      </div>

      <div className="w-[90%] mx-auto p-4 h-[800px] sm:h-[500px] font-poppina"> 
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,dayGridWeek,dayGridDay",
          }}
          dateClick={handleDateClick}
          eventClick={handleEventClick}
          events={events}
          height={window.innerWidth < 640 ? "500px" : "700px"} 
          locale={esLocale}
        
        />
      </div>
    </div>
  );
};

export default Calendario;